import { render, staticRenderFns } from "./CanalCienciaSelect.vue?vue&type=template&id=2b80c0c6"
import script from "./CanalCienciaSelect.vue?vue&type=script&lang=js"
export * from "./CanalCienciaSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports